'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var defineProperty = require('../node_modules/@babel/runtime/helpers/defineProperty.js');
var _typeof = require('../node_modules/@babel/runtime/helpers/typeof.js');
var classCallCheck = require('../node_modules/@babel/runtime/helpers/classCallCheck.js');
var createClass = require('../node_modules/@babel/runtime/helpers/createClass.js');
var possibleConstructorReturn = require('../node_modules/@babel/runtime/helpers/possibleConstructorReturn.js');
var getPrototypeOf = require('../node_modules/@babel/runtime/helpers/getPrototypeOf.js');
var inherits = require('../node_modules/@babel/runtime/helpers/inherits.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function withGoogleMapsAPI() {
  return function (WrappedComponent) {
    var WrappedComponentWithGoogleMapsAPI =
    /*#__PURE__*/
    function (_PureComponent) {
      inherits(WrappedComponentWithGoogleMapsAPI, _PureComponent);

      function WrappedComponentWithGoogleMapsAPI(props) {
        var _this;

        classCallCheck(this, WrappedComponentWithGoogleMapsAPI);

        _this = possibleConstructorReturn(this, getPrototypeOf(WrappedComponentWithGoogleMapsAPI).call(this, props));
        _this.state = {
          googleLoaded: false
        };
        return _this;
      }

      createClass(WrappedComponentWithGoogleMapsAPI, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;

          if (_typeof["default"](window.google) !== 'object') {
            var script = document.createElement('script');
            script.src = "https://maps.googleapis.com/maps/api/js?v=3&key=".concat(process.env.GOOGLE_MAPS_API_KEY, "&libraries=places");
            script.addEventListener('load', function () {
              _this2.setState({
                googleLoaded: true
              });
            });
            script.addEventListener('error', function () {});
            document.body.appendChild(script);
          } else {
            this.setState({
              googleLoaded: true
            });
          }
        }
      }, {
        key: "render",
        value: function render() {
          if (this.state.googleLoaded) {
            return React__default["default"].createElement(WrappedComponent, _objectSpread({}, this.props));
          } else {
            return null;
          }
        }
      }]);

      return WrappedComponentWithGoogleMapsAPI;
    }(React.PureComponent);

    return WrappedComponentWithGoogleMapsAPI;
  };
}

exports.withGoogleMapsAPI = withGoogleMapsAPI;
